export const TOKEN_KEY = '@STS-PDU-@WWL';

export const getItem = () => {
}

export const setItem = () => {
}

export const logoff = () => {
}